module.exports = __webpack_public_path__ + "media/images/teams/CAGLIARI-c2e332bcc06f9251452f792da28cd11e.png";